import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';
import { CourseStep } from '../models/course';

export const createUploadStep = (
  courseId: string,
  stepName: string,
  stepDescription: string,
  order: number,
  initiatingUserId: string
): Promise<CourseStep> => {
  const taskId = uuid.generate();
  return submitCommand(
    courseId,
    {
      id: courseId,
      taskId: taskId,
      taskName: stepName,
      taskDescription: stepDescription,
      order: order,
      initiatingUserId: initiatingUserId,
    },
    'AddUploadTask',
    'UploadTaskIsAddedToTasklist',
    'TaskListError'
  ).then(() => ({
    _id: { id: taskId },
    _type: 'Upload',
    taskName: stepName,
    order,
  }));
};
